import CalenderIcon from './calendar-icon.svg';
import CalenderIconBlack from './calendar-icon-black.svg';
import DrawerIcon from './drawer-icon.svg';
import CircleSelected from './circle-selected.svg';
import CircleUnselected from './circle-unselected.svg';
import ExcludeIcon from './exclude-icon.svg';
import CodeIcon from './code-icon.svg';
import Envelope from './envelope.svg';
import CustomerCode from './customer-code.svg';
import LanguageIcon from './Language-icon.svg';
import SegmentsIcon from './Segments-icon.svg';
import FirmIcon from './firm-icon.svg';
import Location from './location.svg';
import UserIcon from './user-icon.svg';
import OrderWhatsAppSource from './whatsapp-source.svg';
import TagIcon from './tag-icon.svg';
import NoCustomer from './no-customers.svg';
import NoAcceptOrder from './no-accept-order.svg';
import NoDraftOrder from './no-draft-order.svg';
import CheckDone from './check-done.svg';
import DangerIcon from './danger-icon.svg';
import UrlErrorIcon from './url-error-icon.svg';
import OrderIconGray from './order-icon-gray.svg';
import TagIconGray from './tag-icon-gray.svg';
import UserIconGray from './user-icon-gray.svg';
import EmptyProduct from './empty-product.svg';
import DiscountIcon from './discount-icon.svg';
import DiscountIconPurple from './discount-icon-purple.svg';
import MinusIcon from './minus-icon.svg';
import PlusIcon from './plus-icon.svg';
import DeleteIcon from './delete-icon.svg';
import ZotokLogo from './zotok-logo-green.svg';
import OrderSuccess from './order_success.svg';
import NoFulfillOrder from './no-fulfill-order.svg';
import SearchIcon from './search-icon.svg';
import PromotionDiscount from './promotion-discount.svg';
import FreePromotionIcon from './free-promotion-icon.svg';
import MinusBlueIcon from './minus-blue-icon.svg';
import PlusBlueIcon from './plus-blue-icon.svg';
import NoProductIcon from './no-products-icon.svg';
import ReplaceIcon from './replace-icon.svg';
import InputInfoError from './input-info-error.svg';
import InputInfo from './input-info.svg';
import UploadFile from './upload_file.svg';
import UploadFileBlack from './upload-file-black.svg';
import FileUploadImg from './file-upload-img.svg';
import KebabMenu from './kebab-menu.svg';
import SuccesIcon from './success-icon.svg';
import Share from './share.svg';
import Assets from './assets.svg';
import Weight from './weight.svg';
import CloseCross from './close.svg';
import UploadIconBlue from './upload-icon-blue.svg';
import Truck from './truck.svg';
import DriverIcon from './driver.svg';
import Steering from './steering.svg';
import CityIcon from './city.svg';
import Pincode from './pincode.svg';
import CheckBoxBlue from './checked.svg';
import UncheckedBox from './unchecked_checkbox.svg';
import DefaultProduct from './default-product.svg';
import CameraIcon from './camera.svg';
import PhotosIcon from './photos.svg';
import DiscountRedIcon from './discount-red-icon.svg';
import PdfIcon from './pdf.svg';
import Products from './products.svg';
import ProductCatalogueViewTemplate from './parent-variant-view-template.svg';
import ThumbnailViewTemplate from './thumbnail-view-template.svg';
import ExcelViewTemplate from './excel-view-template.svg';
import Checked from './white-check.svg';
import CopyIcon from './copy-icon.svg';
import Retry from './retry.svg';
import InvoicePending from './pending-invoice.svg';
import Seen from './seen.svg';
import Sent from './sent.svg';
import Delivered from './delivered.svg';
import SelectedRadio from './selected-radio.svg';
import PaymentPaidIcon from './payment-paid.svg';
import PaymentConfirmedIcon from './payment-confirmed.svg';
import NoPaymentIcon from './no-payments-icon.svg';
import CheckGreen from './check-green.svg';
import ThreeDot from './three-dot.svg';
import CloseWhite from './close-white.svg';
import ViewImage from './view-image.svg';
import InvoiceBlack from './invoices-black.svg';
import Engaged from './engaged.svg';
import ParseIcon from './parse-icon.svg';
import ImageFrame from './image-frame.svg';
import PencilIcon from './pencil.svg';
import InvoicePaid from './paid-invoice.svg';
import NoInvoicesFound from './no-inovices.svg';
import Clock from './clock.svg';
import AssignMember from './assign-member.svg';
import NewConversation from './new-conversation.svg';
import InProgressConversation from './in-progress-conversation.svg';
import ClosedConversation from './closed-conversation.svg';
import ChangeStatus from './change-status.svg';
import UpiIcon from './upi-icon.svg';
import BankIcon from './bank-icon.svg';
import Whatsapp from './whatsapp.svg';
import SendInvoice from './send-invoice.svg';
import SendPayment from './send-payment.svg';
import Synchronize from './synchronize.svg';
import ArrowDown from './arrow-down.svg';
import ArrowDownBlack from './arrow-down-black.svg';
import ArrowUp from './arrow-up.svg';
import MessageInputRight from './message-input-right-icon.svg';
import ErrorInfo from './error-info.svg';
import Notepad from './notepad.svg';
import Attatch from './attatch.svg';
import Remove from './remove.svg';
import ConversationNotification from './conversation-notification.svg';
import CampaignIcon from './campaign-icon.svg';
import LockIcon from './lock_icon.svg';
import ErrorPurple from './error-purple.svg';
import CartBlue from './cart-blue.svg';
import PaymentGreen from './payment-green.svg';
import NotepadOrange from './notepad-orange.svg';
import MoveIcon from './move.svg';
import RadioChecked from './radio-checked.svg';
import RadioDefault from './radio-default.svg';
import TrashIcon from './trash.svg';
import PhoneIcon from './phone.svg';
import DispatchNoteNotFound from './dispatch-note-not-found.svg';
import UsersIcon from './users-icon.svg';
import BillIcon from './bill.svg';
import EmptyCart from './empty-cart.svg';
import ProductsIcon from './products-icon.svg';
import OrderIcon from './order-icon.svg';
import ZotokLoc from './zotok-loc.svg';
import CalendarSchedule from './calendar-schedule.svg';
import NoInternet from './no-internet.svg';
import NoClockInIcon from './no-clock-in.svg';
import GpsLocation from './gps-location.svg';
import ConfirmCheckOut from './confirm-check-out.svg';
import CurrentLocation from './current-location.svg';
import CustomerSuccess from './customer-success.svg';
import AddCircle from './add-circle.svg';
import CfasIcon from './cfas-icon.svg';
import CheckboxBlack from './checkbox-black.svg';
import CustomersTree from './customers-tree.svg';
import CheckIn from './checkin.svg';
import CheckOut from './checkout.svg';
import CartTransaction from './cart-transaction.svg';
import PaymentTransaction from './payment-transaction.svg';
import ArrowRightBlackFill from './arrow-right-black.svg';
import DownloadNotification from './download-notification.svg';
import SyncFailNotification from './sync-fail-notification.svg';
import PaymentsIcon from './payments-icon.svg';
import InvoicesIcon from './invoices-icon.svg';
import LedgerIcon from './ledger-icon.svg';
import OrdersIcon_ from './orders-icon.svg';
import ReplaceBlueIcon from './Replace.svg';
import addBlueIcon from './addblue.svg';
import minusBlueIcon from './minusblue.svg';
import NoAssignRoutes from './no-assign-routes.svg';
import PriceListIcon from './price-list.svg';
import PendingActivity from './pending-activity.svg';
import ConfirmCheckMark from './confirm-check-mark.svg';
import MapIcon from './map-icon.svg';
import OrdersBlackIcon from './order-black.svg';
import PhoneIconBlack from './phone-black.svg';
import DownloadedIcon from './downloaded-icon.svg';
import NoTeamMembers from './no-team-members.svg';
import NoBeatPlans from './no-beat-plan.svg';
import NoTemplate from './empty-template.svg';
import NoConversation from './no-conversation.svg';
import Invoice from './invoice.svg';
import NoCartItems from './no-cart-item.svg';
import CheckInRequireIcon from './check-in-icon.svg';
import NoDispatchNote from './no-dispatch-note.svg';
import NoSearchIcon from './no-search.svg';
import NoWhatsApp from './no-whatsapp.svg';
import CartIcon from './cart.svg';
import CashIcon from './cash.svg';
import ChampionBadgeIcon from './champion-badge.svg';
import ConversationFilledIcon from './conversation-filled.svg';
import RupeeIcon from './rupee.svg';
import ArrowLeft from './arrow_left.svg';
import LockBlack from './lock.svg';
import NoWhatsAppBlack from './no-whatsapp-black.svg';
import CreditLimit from './credit-limit.svg';
import OutStandingAmount from './outstanding-amount.svg';
import segmentIcon from './Segments.svg';
import SynchronizeIcon from './synchronize-icon.svg';
import conversationModuleIcon from './conversation.svg';
import notesModuleIcon from './notes.svg';
import segmentsRoutesIcon from './segment-route.svg';
import PlusIconNew from './plusIconitem.svg';
import ClockSuccess from './clock-success.svg';
import CheckInOutSuccess from './check-in-out-success.svg';
import NoSemanticQuery from './no-semantic-query.svg';
import ZotokLogoWhite from './zotok-logo-white.svg';
import PercentIconFilled from './percent-icon.svg';
import RupeeIconFilled from './rupee-icon.svg';
import SchemeFreeIcon from './scheme_free.svg';
import CancelOrderIcon from './cancel-order.svg';

export const SVGS = {
  CancelOrderIcon,
  RupeeIconFilled,
  PercentIconFilled,
  NoSemanticQuery,
  CheckInOutSuccess,
  ClockSuccess,
  CreditLimit,
  OutStandingAmount,
  NoWhatsAppBlack,
  LockBlack,
  ArrowLeft,
  CartIcon,
  CashIcon,
  ChampionBadgeIcon,
  ConversationFilledIcon,
  RupeeIcon,
  NoWhatsApp,
  NoSearchIcon,
  NoDispatchNote,
  CheckInRequireIcon,
  NoCartItems,
  NoConversation,
  NoTemplate,
  DownloadedIcon,
  PhoneIconBlack,
  UploadFileBlack,
  OrdersBlackIcon,
  MapIcon,
  ConfirmCheckMark,
  PendingActivity,
  ArrowRightBlackFill,
  NoAssignRoutes,
  CustomersTree,
  CheckboxBlack,
  CfasIcon,
  AddCircle,
  CustomerSuccess,
  CurrentLocation,
  ConfirmCheckOut,
  GpsLocation,
  NoClockInIcon,
  NoInternet,
  CalendarSchedule,
  ZotokLoc,
  PhoneIcon,
  LockIcon,
  ArrowDown,
  ArrowDownBlack,
  ArrowUp,
  Synchronize,
  SendPayment,
  SendInvoice,
  UpiIcon,
  BankIcon,
  PencilIcon,
  NoInvoicesFound,
  Engaged,
  ImageFrame,
  ParseIcon,
  InvoiceBlack,
  ViewImage,
  CloseWhite,
  ThreeDot,
  CheckGreen,
  NoPaymentIcon,
  PaymentPaidIcon,
  PaymentConfirmedIcon,
  SelectedRadio,
  DiscountRedIcon,
  ReplaceIcon,
  NoProductIcon,
  MinusBlueIcon,
  PlusBlueIcon,
  FreePromotionIcon,
  PromotionDiscount,
  SearchIcon,
  NoFulfillOrder,
  DeleteIcon,
  MinusIcon,
  PlusIcon,
  DiscountIcon,
  EmptyProduct,
  UserIconGray,
  TagIconGray,
  OrderIconGray,
  UrlErrorIcon,
  DangerIcon,
  CheckDone,
  NoDraftOrder,
  NoAcceptOrder,
  NoCustomer,
  TagIcon,
  CodeIcon,
  Envelope,
  CustomerCode,
  LanguageIcon,
  SegmentsIcon,
  FirmIcon,
  Location,
  UserIcon,
  CalenderIcon,
  CalenderIconBlack,
  DrawerIcon,
  CircleSelected,
  CircleUnselected,
  ExcludeIcon,
  OrderWhatsAppSource,
  ZotokLogo,
  OrderSuccess,
  InputInfoError,
  InputInfo,
  UploadFile,
  FileUploadImg,
  KebabMenu,
  SuccesIcon,
  Share,
  Assets,
  Weight,
  CloseCross,
  UploadIconBlue,
  Truck,
  DriverIcon,
  Steering,
  CityIcon,
  Pincode,
  CheckBoxBlue,
  UncheckedBox,
  DefaultProduct,
  CameraIcon,
  PhotosIcon,
  PdfIcon,
  Products,
  ProductCatalogueViewTemplate,
  ThumbnailViewTemplate,
  ExcelViewTemplate,
  Checked,
  CopyIcon,
  Retry,
  InvoicePending,
  Seen,
  Sent,
  Delivered,
  InvoicePaid,
  Clock,
  AssignMember,
  NewConversation,
  InProgressConversation,
  ClosedConversation,
  ChangeStatus,
  Whatsapp,
  MessageInputRight,
  ErrorInfo,
  Notepad,
  Attatch,
  Remove,
  ConversationNotification,
  CampaignIcon,
  ErrorPurple,
  CartBlue,
  PaymentGreen,
  DispatchNoteNotFound,
  NotepadOrange,
  MoveIcon,
  RadioChecked,
  RadioDefault,
  TrashIcon,
  UsersIcon,
  BillIcon,
  EmptyCart,
  ProductsIcon,
  OrderIcon,
  CheckIn,
  CheckOut,
  CartTransaction,
  PaymentTransaction,
  DownloadNotification,
  SyncFailNotification,
  SchemeFreeIcon,
  PaymentsIcon,
  InvoicesIcon,
  LedgerIcon,
  OrdersIcon_,
  ReplaceBlueIcon,
  addBlueIcon,
  minusBlueIcon,
  PriceListIcon,
  DiscountIconPurple,
  NoBeatPlans,
  NoTeamMembers,
  Invoice,
  segmentIcon,
  SynchronizeIcon,
  conversationModuleIcon,
  notesModuleIcon,
  PlusIconNew,
  ZotokLogoWhite,
};
